import { dataSyncCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSyncCircle = /*#__PURE__*/createIcon(dataSyncCircle)
export default IconSyncCircle
